

export default function TEMPLATE({ isNavOpen }) {

  return (
    <div className={`${isNavOpen ? 'body-squeezed' : 'body'}`}>
        <h2>TEMPLATE1</h2>
        <h2>TEMPLATE2</h2>
        <h2>TEMPLATE</h2>
        <h2>TEMPLATE</h2>
        <h2>TEMPLATE</h2>
        <h2>TEMPLATE</h2>
        <h2>TEMPLATE</h2>
        <h2>TEMPLATE</h2>
        <h2>TEMPLATE</h2>
        <h2>TEMPLATE10</h2>
        <h2>TEMPLATE1</h2>
        <h2>TEMPLATE2</h2>
        <h2>TEMPLATE</h2>
        <h2>TEMPLATE</h2>
        <h2>TEMPLATE</h2>
        <h2>TEMPLATE</h2>
        <h2>TEMPLATE</h2>
        <h2>TEMPLATE</h2>
        <h2>TEMPLATE</h2>
        <h2>TEMPLATE10</h2>
    </div>
    
  )
}